/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { AbstractPersonRule } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { AppErrorHandler } from '../error-handler/app-error-handler';
import { PersonRuleService } from '../service/person-rule.service';

@Pipe({
    name: 'personRequirementRuleName',
    standalone: false,
})
export class PersonRequirementRuleNamePipe implements PipeTransform {
    constructor(
        private appErrorHandler: AppErrorHandler,
        private personRuleService: PersonRuleService,
    ) {}

    transform(rule: AbstractPersonRule, isOrderingRule?: boolean): Observable<string> {
        return this.personRuleService.fetchRuleInfoText(rule, !!isOrderingRule).pipe(this.appErrorHandler.defaultErrorHandler());
    }
}
